import {Component, OnInit} from '@angular/core';
import {ApiService} from "../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-filter-editor',
  templateUrl: './filter-editor.component.html',
  styleUrls: ['./filter-editor.component.css']
})
export class FilterEditorComponent implements OnInit {
  public categories: string[] = [];
  public currentCategory = '';
  private sub: any;
  public search: string;

  constructor(public apiService: ApiService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.apiService.getCategories().subscribe(categories => this.categories = categories);

    this.sub = this.route.params.subscribe(params => {
      this.currentCategory = params['category'];
      if(!this.currentCategory){
        this.currentCategory='';
      }
      this.apiService.setCategory(this.currentCategory);
    });
  }


  toCategory(cat: string) {
    this.apiService.setSearch('', false);
    this.search='';
    this.router.navigateByUrl('image/' + encodeURIComponent(cat));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
